import { initializeChakraComponent } from 'Shared/chakra-initialize';
import PopupContainer from './popup_container';
import * as actions from './actions';

export { actions as PopupActions };

initializeChakraComponent('PopupModal', PopupContainer);
